var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4249 1.56461C19.6089 1.38054 19.8514 1.28234 20.1009 1.28234C20.348 1.28234 20.5922 1.3788 20.7778 1.56414C21.1562 1.94143 21.1547 2.54138 20.7782 2.91789L12.3888 11.3088L20.776 19.6988C20.7762 19.699 20.7764 19.6991 20.7766 19.6993C21.1545 20.0763 21.1533 20.6755 20.7778 21.052C20.5859 21.2452 20.3393 21.3333 20.1009 21.3333C19.8611 21.3333 19.6136 21.243 19.4236 21.053L11.0343 12.6622L2.64816 21.0511C2.6478 21.0515 2.64745 21.0518 2.6471 21.0522C2.45485 21.2456 2.20591 21.3333 1.96897 21.3333C1.72865 21.3333 1.48411 21.244 1.29319 21.0532C1.29311 21.0531 1.29304 21.0531 1.29296 21.053L1.71 20.636C1.56314 20.4898 1.56314 20.2635 1.71 20.1167L1.29296 19.6997L9.6824 11.3088L1.29389 2.91882C1.29371 2.91864 1.29352 2.91846 1.29334 2.91827C0.915014 2.54099 0.916541 1.94109 1.29296 1.56461C1.48316 1.37438 1.72611 1.2843 1.96897 1.2843C2.21041 1.2843 2.45579 1.37408 2.64629 1.56461L11.0356 9.95537L19.4249 1.56461ZM19.4249 1.56461L19.8419 1.98158L19.4249 1.56461Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.17947
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.dd88d640373a4b0111d7f42ba9525b55.svg";
export { ForwardRef as ReactComponent };